import { Log, LogTypeEnum } from 'src/types';

export const checkIsLogSpecificType = <T extends LogTypeEnum>(log: Log, type: T): log is Log<T> => log.type === type;
